import type { DeepPartial } from '@luna/utils-ts';

import type { OwnTransfer } from './OwnTransfer';

export const RS: DeepPartial<OwnTransfer> = {
    enabled: false,
};
